import { useContext } from "react"
import { ProfileContext } from ".";

export const  useProfile = () =>{
    const context = useContext(ProfileContext);

    return context;
}